<div class="segmentConnection__cont">
  <app-ds-alert
    [type]="alertType"
    [size]="alertSize"
    [align]="alertAlign"
    [icon]="icon"
    [message]="message">
  </app-ds-alert>
</div>